import { render, staticRenderFns } from "./ui.cattle.io.navlink.vue?vue&type=template&id=9c98c534&"
import script from "./ui.cattle.io.navlink.vue?vue&type=script&lang=js&"
export * from "./ui.cattle.io.navlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports